<template>
  <b-modal
    hide-footer
    id="modal-update-comment"
    ref="modal-update-comment"
    size="md"
    title="แก้ไขความเห็นเจ้าหน้าที่"
  >
    <b-card>
      <b-form-group label="ความเห็นเดิม">
        <b-form-textarea
          v-model="oldComment"
          :readonly="true"
        ></b-form-textarea>
      </b-form-group>
      <b-form-group class="mt-2" label="ความเห็นใหม่">
        <b-form-textarea v-model="comment"></b-form-textarea>
      </b-form-group>
      <footer
        id="modal-transfer___BV_modal_footer_"
        class="modal-footer d-flex justify-content-between"
      >
        <button type="button" class="btn btn-secondary" block @click="onCancel">
          ยกเลิก
        </button>
        <button type="button" class="btn btn-primary" block @click="onSubmit">
          บันทึก
        </button>
      </footer>
    </b-card>
  </b-modal>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BModal,
  BForm,
  BButton,
  BFormTextarea,
  BFormDatepicker,
  BCard,
} from "bootstrap-vue";

import vSelect from "vue-select";
import { VueAutosuggest } from "vue-autosuggest";
import * as complaintManageStore from "@/store/api/complaintManage/index.js";
import * as lang from "vuejs-datepicker/src/locale";
import * as userData from "@/auth/localStorageUtils.js";
import appsettings from "@/store/app-settings";

export default {
  components: {
    BRow,
    BCol,
    BFormDatepicker,
    BFormGroup,
    BFormInput,
    BButton,
    BModal,
    BFormTextarea,
    BCard,
    vSelect,
    VueAutosuggest,
    lang,
    userData,
  },
  data() {
    return {
      trackingDetailId: "",
      oldComment: "",
      comment: "",
    };
  },
  props: {
    userId: {
      type: String,
    },
  },
  computed: {
    identityState() {
      return this.personal.identity.length === 13 ? true : false;
    },
  },
  mounted() {
    this.complaintId = this.$route.query.id;
  },
  methods: {
    setModalData(trackingDetailId, oldComment) {
      this.trackingDetailId = trackingDetailId;
      this.oldComment = oldComment;
      this.comment = "";
    },
    onCancel() {
      console.log("onCancel");
      this.$refs["modal-update-comment"].hide();
    },
    onSubmit() {
      console.log("onSubmit");

      const _this = this;

      this.$swal({
        title: "ยืนยันการบันทึกข้อมูล?",
        text: "",
        icon: "success",
        showCancelButton: true,
        confirmButtonText: "บันทึก",
        cancelButtonText: "ยกเลิก",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-primary ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          const params = {
            trackingComplaintDetailId: _this.trackingDetailId,
            complaintId: _this.complaintId,
            comment: _this.comment,
          };
          complaintManageStore
            .updateComment(params)
            .then((response) => {
              if (response.data.success === true) {
                _this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
                  title: `ระบบได้บันทึกการแก้ไขของท่านแล้ว`,
                  variant: "success",
                  solid: false,
                });
                _this.$refs["modal-update-comment"].hide();
                _this.$router.go(_this.$router.currentRoute);
              } else {
                _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                  title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                  variant: "danger",
                  solid: false,
                });
              }
            })
            .catch((error) => {
              console.log("error", error);
              _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                variant: "danger",
                solid: false,
              });
            });
        }
      });
    },
  },
};
</script>

<style></style>
